var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-content",attrs:{"id":"inner-wrap"}},[_c('div',{staticClass:"mypage-wrap"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }